import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse } from "@api";

import type { IPathBaseParam } from "./path";
import type { IEnterUnitsDto } from "./types";

const postApis = createPostApi<
  IApiResponse<unknown>,
  IPathBaseParam,
  IEnterUnitsDto
>("stores.warehouses.enterUnits");

export const enterUnits = {
  ...postApis,
};
